import { render, staticRenderFns } from "./BrowserWireframe.vue?vue&type=template&id=0eddd1fa&"
import script from "./BrowserWireframe.vue?vue&type=script&lang=js&"
export * from "./BrowserWireframe.vue?vue&type=script&lang=js&"
import style0 from "./BrowserWireframe.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports